import { Plugins } from "@kanpla/types";

export const getFieldTitle = (
  noteKey: string,
  fields: Array<Plugins.TextInputField>
) => fields.find((field) => field.key === noteKey)?.title || noteKey;
